module.exports = __webpack_public_path__ + "static/media/moon-white.559df9c1.svg";